module.exports = __webpack_public_path__ + "img/奔宝德尔福.png";